// extracted by mini-css-extract-plugin
export var label = "layout-module--label--dd921";
export var loader = "layout-module--loader--f461b";
export var root = "layout-module--root--7eb23";